import React from 'react';
export default function IconCircleArrowUpFilled(){
  return(
    <svg  className="icon icon-tabler icons-tabler-filled icon-tabler-circle-arrow-up"
      fill="currentColor"  height="24"  viewBox="0 0 24 24"  width="24"
      xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"
        stroke="none"/>
      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4.98 3.66l-.163 .01l-.086 .016l-.142 .045l-.113 .054l-.07 .043l-.095 .071l-.058 .054l-4 4l-.083 .094a1 1 0 0 0 1.497 1.32l2.293 -2.293v5.586l.007 .117a1 1 0 0 0 1.993 -.117v-5.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4 -4l-.082 -.073l-.089 -.064l-.113 -.062l-.081 -.034l-.113 -.034l-.112 -.02l-.098 -.006z" />
    </svg>
  );
}
